import React from 'react';

import { cx } from '@travel/utils';

import styles from './timeLineSection.module.scss';

import type { ReactNode } from 'react';

export enum PenaltyType {
  CANCELLATION_PENALTY,
  NO_SHOW_PENALTY,
}

type Props = {
  isOnly: boolean;
  isLast: boolean;
  color?: 'free' | 'partialPenalty' | 'fullPenalty';
  amount: string | ReactNode;
  deadLine: string | ReactNode;
  className?: string;
  iconClassName?: string;
  arrowClassName?: string;
  lineClassName?: string;
  cancellationPolicyClassName?: string;
  deadLineClassName?: string;
};

function TimeLineSection(props: Props) {
  const {
    isOnly,
    isLast,
    color = 'partialPenalty',
    amount,
    deadLine,
    className,
    iconClassName,
    arrowClassName,
    lineClassName,
    cancellationPolicyClassName,
    deadLineClassName,
    ...rest
  } = props;

  return (
    <div
      className={cx(styles.container, className)}
      data-testid="timeLineSection-wrapper"
      {...rest}
    >
      {!isOnly && (
        <div>
          <div
            className={cx(styles.dot, styles[color], iconClassName)}
            data-testid="timeLineSection-dot"
          >
            <span className={cx(styles.arrow, styles[color], arrowClassName)} />
          </div>
          {!isLast && (
            <span
              className={cx(styles.line, styles[color], lineClassName)}
              data-testid="timeLineSection-last"
            />
          )}
        </div>
      )}
      <div
        className={cx(styles.cancellationPolicyDescription, cancellationPolicyClassName)}
        data-testid="timeLineSection-amount"
      >
        {deadLine && (
          <div
            className={cx(styles.date, deadLineClassName)}
            data-testid="timeLineSection-deadLine"
          >
            {deadLine}
          </div>
        )}
        {amount}
      </div>
    </div>
  );
}

export default TimeLineSection;
